import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const mediaItemFallbackContainer = style([
  {
    position: 'relative',
    width: '100%',
    height: 'auto',
  },
]);

export const mediaItemFallbackLabel = style([
  typography.labelSm,
  {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    textAlign: 'center',
    color: themeVars.container.foreground.tertiary,
  },
]);
